import * as React from 'react';
import type { SVGProps } from 'react';
const UpChevronIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.8337 13.6696L11.0315 8.90628C10.4643 8.34374 9.53631 8.34374 8.96918 8.90628L4.16699 13.6696"
      stroke="#9099A5"
      strokeWidth="2.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default UpChevronIcon;
